<template>
  <v-expansion-panels>
    <v-expansion-panel>
      <v-expansion-panel-title class="pa-0 pe-3">
        <v-card-title>
          <span>{{ t('maintenance_data') }}</span>
          <span v-if="!objectExists" class="text-red ml-2">MISSING INFORMATIONS!</span>
        </v-card-title>
      </v-expansion-panel-title>
      <v-expansion-panel-text>
        <v-form :id="formId" @submit.prevent="submit" :class="{ 'defaults-applied': usingDefaults }">
          <v-row>
            <v-col cols="6">
              <v-textarea
                :label="t('how_approach_client')"
                density="compact"
                v-model="form.how_approach_client.value.value"
                :error-messages="form.how_approach_client.errorMessage.value"
              />
              <v-select
                :label="t('electrical_cabinet_type')"
                :items="['standard', 'modbus', 'retrofit']"
                density="compact"
                v-model="form.electrical_cabinet_type.value.value"
                :error-messages="form.electrical_cabinet_type.errorMessage.value"
              />
              <v-select
                :label="t('electrical_cabinet_position')"
                :items="['inside', 'outside']"
                density="compact"
                v-model="form.electrical_cabinet_where.value.value"
                :error-messages="form.electrical_cabinet_where.errorMessage.value"
              />
              <v-checkbox
                :label="t('electrical_cabinet_with_key')"
                density="compact"
                v-model="form.electrical_cabinet_with_key.value.value"
                :error-messages="form.electrical_cabinet_with_key.errorMessage.value"
              />
              <v-checkbox
                :label="t('cabinet_high_position')"
                density="compact"
                v-model="form.high_cabinet.value.value"
                :error-messages="form.high_cabinet.errorMessage.value"
              />
              <v-checkbox
                :label="t('grounded_com_braid')"
                density="compact"
                type="checkbox"
                v-model="form.grounded_com_braid.value.value"
                :error-messages="form.grounded_com_braid.errorMessage.value"
              />
              <v-text-field
                :label="t('gnd_to_neutral')"
                append-inner-icon="mdi-alpha-v"
                density="compact"
                v-model="form.volt_gnd_to_neutral.value.value"
                :error-messages="form.volt_gnd_to_neutral.errorMessage.value"
              />
              <v-text-field
                :label="t('phase_to_neutral')"
                append-inner-icon="mdi-alpha-v"
                density="compact"
                v-model="form.volt_phase_to_neutral.value.value"
                :error-messages="form.volt_phase_to_neutral.errorMessage.value"
              />
              <v-textarea
                :label="t('notes_maintenance')"
                density="compact"
                v-model="form.notes_maintenance.value.value"
                :error-messages="form.notes_maintenance.errorMessage.value"
              />
            </v-col>
            <v-col v-if="originalPark ? originalPark['has_pilotage'] === true : false" cols="6">
              <v-card variant="outlined" :title="t('pilotage')">
                <v-card-text>
                  <v-select
                    :label="t('pilotage_board_model')"
                    :items="['modbus', 'relay_retrofit', 'relay', 'potentiometer', 'potentiometer_v1.2']"
                    density="compact"
                    v-model="form.pilotage.pilotage_card.value.value"
                    :error-messages="form.pilotage.pilotage_card.errorMessage.value"
                  />
                  <v-select
                    :label="t('measurement_board_model')"
                    :items="['lechacal', 'modbus']"
                    density="compact"
                    v-model="form.pilotage.measure_card.value.value"
                    :error-messages="form.pilotage.measure_card.errorMessage.value"
                  />
                  <v-card :title="t('measurement_board_data')" variant="outlined">
                    <v-card-text v-if="form.pilotage.measure_card.value.value === 'lechacal'">
                      <v-select
                        :label="t('card_ampere')"
                        :items="['40', '100', '200', '400', '600']"
                        density="compact"
                        v-model="form.pilotage.measure_card_data.card_amps.value.value"
                        :error-messages="form.pilotage.measure_card_data.card_amps.errorMessage.value"
                      />
                      <v-select
                        :label="t('clamp_ampere')"
                        :items="['100', '200', '400', '600']"
                        density="compact"
                        v-model="form.pilotage.measure_card_data.clamp_amps.value.value"
                        :error-messages="form.pilotage.measure_card_data.clamp_amps.errorMessage.value"
                      />
                    </v-card-text>
                    <v-card-text v-else>
                      {{ t('no_additional_data_needed') }}
                    </v-card-text>
                  </v-card>
                  <v-checkbox
                    class="pt-4"
                    :label="t('computer_grounded')"
                    density="compact"
                    v-model="form.pilotage.computer_grounded.value.value"
                    :error-messages="form.pilotage.computer_grounded.errorMessage.value"
                  />
                  <v-checkbox
                    :label="t('new_epc')"
                    density="compact"
                    v-model="form.pilotage.modified_epc.value.value"
                    :error-messages="form.pilotage.modified_epc.errorMessage.value"
                  />
                  <v-select
                    :label="t('computer_electrical_protection')"
                    :items="['none', 'fuse', 'C16', 'C2']"
                    density="compact"
                    v-model="form.pilotage.computer_elec_prot.value.value"
                    :error-messages="form.pilotage.computer_elec_prot.errorMessage.value"
                  />
                  <v-select
                    :label="t('gsm_modem')"
                    :items="['none', 'huawei', 'teltonika']"
                    density="compact"
                    v-model="form.pilotage.gsm_model.value.value"
                    :error-messages="form.pilotage.gsm_model.errorMessage.value"
                  />
                  <v-card :title="t('gsm_modem_data')" variant="outlined">
                    <v-card-text v-if="['none', undefined].includes(form.pilotage.gsm_model.value.value)">
                      {{ t('no_additional_data_needed') }}
                    </v-card-text>
                    <v-card-text v-else>
                      <v-select
                        :label="t('sim_provider')"
                        :items="['soracom', 'webbing']"
                        density="compact"
                        v-model="form.pilotage.gsm_data.sim_provider.value.value"
                        :error-messages="form.pilotage.gsm_data.sim_provider.errorMessage.value"
                      />
                      <v-checkbox
                        v-if="form.pilotage.gsm_model.value.value === 'teltonika'"
                        :label="t('new_teltonika_cable')"
                        density="compact"
                        v-model="form.pilotage.gsm_data.new_teltonika_cable.value.value"
                        :error-messages="form.pilotage.gsm_data.new_teltonika_cable.errorMessage.value"
                      />
                    </v-card-text>
                  </v-card>
                  <v-textarea
                    class="mt-2"
                    :label="t('connectivity_notes')"
                    density="compact"
                    v-model="form.pilotage.connectivity_notes.value.value"
                    :error-messages="form.pilotage.connectivity_notes.errorMessage.value"
                  />
                </v-card-text>
              </v-card>
            </v-col>
            <v-col v-else cols="6">
              <v-label :text="t('no_pilotage')"/>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-card :title="t('cp_data')" variant="outlined"
                      v-if="form.electrical_cabinet_type.value.value !== 'retrofit'">
                <v-card-text v-if="originalPark !== null">
                  <v-row>
                    <v-col
                      cols="4"
                      v-for="(cp, index) in originalPark.chargingstations.sort((a, b) => objComparatorNumber(a, b, 'park_bnum'))"
                      :key="cp['park_bnum']">
                      <v-card>
                        <v-card-title>
                          {{ t('cp') }} {{ cp['park_bnum'] }}
                        </v-card-title>
                        <v-card-text>
                          <v-row>
                            <v-col v-if="cp['bnum'] in prevCPData">
                              <v-select
                                :label="t('socket_type')"
                                :items="['with_cable', 'female', 'disabled', 'terza_female']"
                                density="compact"
                                v-model="prevCPData[cp['bnum']]['socket_type']"
                                :error-messages="errors[`cps[${index}].socket_type`]"
                              />
                              <v-card :title="t('socket_data')" variant="outlined" class="mb-2">
                                <v-card-text v-if="prevCPData[cp['bnum']]['socket_type'] === 'female'">
                                  <!-- TODO: Error-Messages che puntano direttamente a socket_data??? -->
                                  <v-select
                                    :label="t('model')"
                                    :items="['Besen']"
                                    density="compact"
                                    v-model="prevCPData[cp['bnum']]['socket_data']['model']"
                                    :error-messages="errors[`cps[${index}].socket_data`]"
                                  />
                                  <v-select
                                    :label="t('solenoid')"
                                    :items="['none', 'blue', 'black', 'orange', 'pink']"
                                    density="compact"
                                    v-model="prevCPData[cp['bnum']]['socket_data']['solenoid']"
                                    :error-messages="errors[`cps[${index}].socket_data`]"
                                  />
                                  <v-checkbox
                                    :label="t('tips_6mm2')"
                                    density="compact"
                                    v-model="prevCPData[cp['bnum']]['socket_data']['tips_6mm2']"
                                    :error-messages="errors[`cps[${index}].socket_data`]"
                                  />
                                </v-card-text>
                                <v-card-text v-else-if="prevCPData[cp['bnum']]['socket_type'] !== 'disabled'">
                                  {{ t('no_additional_info') }}
                                </v-card-text>
                                <v-card-text v-else-if="prevCPData[cp['bnum']]['socket_type'] === 'disabled'">
                                  {{ t('disabled') }}
                                </v-card-text>
                              </v-card>
                              <v-text-field
                                :label="t('capacity_nf')"
                                density="compact"
                                v-model="prevCPData[cp['bnum']]['capacity_nF']"
                                :error-messages="errors[`cps[${index}].capacity_nF`]"
                                v-if="prevCPData[cp['bnum']]['socket_type'] !== 'disabled'"
                              />
                              <v-select
                                :label="t('communication_cable')"
                                :items="['ethernet', 'LIYCY', 'others']"
                                density="compact"
                                v-model="prevCPData[cp['bnum']]['communication_cable']"
                                :error-messages="errors[`cps[${index}].communication_cable`]"
                                v-if="prevCPData[cp['bnum']]['socket_type'] !== 'disabled'"
                              />
                            </v-col>
                          </v-row>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col class="d-flex">
            <v-btn
              v-if="originalPark !== null && !objectExists"
              @click="fillWithDefaults"
              class="flex-fill me-2"
              :text="t('fill_defaults')"
              color="blue"
            />
            <v-btn type="submit" class="flex-fill ms-2" :text="t('save_data')" :form="formId" color="orange"/>
          </v-col>
        </v-row>
      </v-expansion-panel-text>
    </v-expansion-panel>
  </v-expansion-panels>
</template>

<script setup>
import { onMounted, ref, toRefs, useId, watch } from "vue";
import structuredClone from '@ungap/structured-clone'; // POLYFILL JS < 2022
import * as yup from 'yup';
import { useFieldArray, useForm } from 'vee-validate';
import { getFormFromSchemaRecursive, objComparatorNumber, setObjectIntoFormBySchema } from "@/utils.js";
import { createMaintenanceData, fetchMaintenanceData, modifyMaintenanceData } from "@/remote/maintenancedata.js";
import { useI18n } from "vue-i18n";

const { t } = useI18n({ inheritLocale: true, useScope: 'local' });
const formId = useId();

// General State
const useAlerts = defineModel('useAlerts');
const loadingOverlay = defineModel('loadingOverlay');
const props = defineProps(['originalPark']);
const { originalPark } = toRefs(props);
const emit = defineEmits(['updated']);
const objectExists = ref(false);
const prevCPData = ref({});
const usingDefaults = ref(false);

// Form
const socketDataSchema = yup.object({
  model: yup.string().required().default(null),
  solenoid: yup.string().required().default(null),
  tips_6mm2: yup.boolean().required().default(false),
});
const cpSchema = yup.object({
  socket_type: yup.string().required().default(null),
  socket_data: socketDataSchema.required().when({
    is: (val) => val !== 'female',
    then: (schema) => schema.omit(['model', 'solenoid', 'tips_6mm2'])
  }).default(() => socketDataSchema.getDefault()),
  capacity_nF: yup.number().nullable().when('socket_type', {
    is: (val) => val !== 'disabled',
    then: (schema) => schema.required(),
  }).default(null),
  communication_cable: yup.string().nullable().when('socket_type', {
    is: (val) => val !== 'disabled',
    then: (schema) => schema.required(),
  }).default(null),
});
// noinspection JSCheckFunctionSignatures
const pilotageSchema = yup.object({
  connectivity_notes: yup.string().nonNullable().required(),
  modified_epc: yup.boolean().required(),
  computer_elec_prot: yup.string().required(),
  pilotage_card: yup.string().required(),
  measure_card: yup.string().required(),
  measure_card_data: yup.object({
    card_amps: yup.string().required(),
    clamp_amps: yup.string().required(),
  }).required().when('measure_card', {
    is: 'modbus',
    then: (schema) => schema.omit(['card_amps', 'clamp_amps']),
  }),
  computer_grounded: yup.boolean().required(),
  gsm_model: yup.string().required(),
  gsm_data: yup.object({
    sim_provider: yup.string().required(),
    new_teltonika_cable: yup.boolean().required(),
  }).required().when('gsm_model', {
    is: (val) => val !== "" && val !== 'teltonika',
    then: (schema) => schema.omit(['new_teltonika_cable'])
  }).when('gsm_model', {
    is: 'none',
    then: (schema) => schema.omit(['new_teltonika_cable', 'sim_provider'])
  })
});
// noinspection JSCheckFunctionSignatures
const schema = yup.object({
  cps: yup.array().of(cpSchema),
  pilotage: pilotageSchema.nullable(),
  electrical_cabinet_type: yup.string().required(),
  electrical_cabinet_where: yup.string().required(),
  electrical_cabinet_with_key: yup.boolean().required(),
  how_approach_client: yup.string().required(),
  high_cabinet: yup.boolean().required(),
  grounded_com_braid: yup.boolean().required(),
  volt_gnd_to_neutral: yup.number().required(),
  volt_phase_to_neutral: yup.number().required(),
  notes_maintenance: yup.string().nonNullable(),
});

const { handleSubmit, resetForm, errors } = useForm({
  validationSchema: schema
});

const form = getFormFromSchemaRecursive(schema);
const { push: cps_push, update: cps_update, replace: cps_replace } = useFieldArray('cps');

async function fetchForm(parkId) {
  cps_replace([]);  // Remove all cps
  const md = await fetchMaintenanceData(parkId);
  if (md === null) {
    console.log("Maintenance Data Not Found");
    resetForm();
    objectExists.value = false;
    // Populate cps
    for (const [i, cs] of originalPark.value['chargingstations'].sort((a, b) => objComparatorNumber(a, b, 'park_bnum')).entries()) {
      const d = cpSchema.getDefault();
      d['chargingstation'] = cs['bnum'];
      cps_push(d);
      d['cps_index'] = i;
      // noinspection JSUnresolvedReference
      prevCPData.value[cs['bnum']] = d;
    }
  } else {
    console.log("Maintenance Data Found");
    setObjectIntoFormBySchema(md, form, schema, ['cps']);  // TODO: Non credo funzioni con l'array CPS
    objectExists.value = true;
    // Populate cps
    for (const [i, cs] of originalPark.value['chargingstations'].sort((a, b) => objComparatorNumber(a, b, 'park_bnum')).entries()) {
      const mdcp = md['cps'].find((x) => x['chargingstation'] === cs['bnum']) || null;
      if (mdcp === null) {
        const d = cpSchema.getDefault();
        d['chargingstation'] = cs['bnum'];
        cps_push(d);
        d['cps_index'] = i;
        // noinspection JSUnresolvedReference
        prevCPData.value[cs['bnum']] = d;
      } else {
        const d = structuredClone(mdcp);
        cps_push(d);
        d['cps_index'] = i;
        // noinspection JSUnresolvedReference
        prevCPData.value[cs['bnum']] = d;
      }
    }
  }
}

watch(prevCPData, (newValue) => {
  for (const key in newValue) {
    const field = newValue[key];
    const { cps_index, ...data } = field;
    cps_update(cps_index, data);
  }
}, { deep: true });

watch(originalPark, async (newValue) => {
  await fetchForm(newValue.id);
});

onMounted(async () => {
  if (originalPark.value !== null) {
    await fetchForm(originalPark.value.id);
  }
});

function fillWithDefaults() {
  // Main form
  form.electrical_cabinet_type.value.value = "standard";
  form.electrical_cabinet_where.value.value = "inside";
  form.grounded_com_braid.value.value = true;
  form.volt_gnd_to_neutral.value.value = 0;
  form.volt_phase_to_neutral.value.value = 0;
  form.notes_maintenance.value.value = ".";
  form.how_approach_client.value.value = ".";

  // Pilotage
  if (originalPark.value && originalPark.value.has_pilotage) {
    form.pilotage.pilotage_card.value.value = "potentiometer";
    form.pilotage.measure_card.value.value = "lechacal";
    form.pilotage.measure_card_data.card_amps.value.value = '100';
    form.pilotage.measure_card_data.clamp_amps.value.value = '100';
    form.pilotage.computer_grounded.value.value = true;
    form.pilotage.computer_elec_prot.value.value = "fuse";
    form.pilotage.gsm_model.value.value = "teltonika";
    form.pilotage.gsm_data.sim_provider.value.value = "webbing";
    form.pilotage.gsm_data.new_teltonika_cable.value.value = true;
    form.pilotage.connectivity_notes.value.value = ".";
  }

  // CP Data
  for (const bnum in prevCPData.value) {
    prevCPData.value[bnum].socket_type = "female";
    if (!prevCPData.value[bnum].socket_data) {
      prevCPData.value[bnum].socket_data = {};
    }
    prevCPData.value[bnum].socket_data.model = "Besen";
    prevCPData.value[bnum].socket_data.solenoid = "blue";
    prevCPData.value[bnum].socket_data.tips_6mm2 = true;
    prevCPData.value[bnum].capacity_nF = 0;
    prevCPData.value[bnum].communication_cable = "LIYCY";
  }

  usingDefaults.value = true;
}

const submit = handleSubmit(async (values) => {
  values['park'] = originalPark.value.id;

  if (values.electrical_cabinet_type === 'retrofit') {
    values.cps.forEach(cp => {
      cp.socket_type = 'disabled';
      cp.capacity_nF = null;
      cp.communication_cable = '';
      cp.socket_data = {};
    });
  }

  // Proper value for socket_type not female
  for (const cp of values['cps']) {
    if (cp['socket_type'] !== 'female') {
      for (const f of ['model', 'solenoid', 'tips_6mm2']) delete cp['socket_data'][f];
    }
  }
  // LOG
  console.log("VALUES SUBMIT");
  console.log(values);
  loadingOverlay.value = true;
  try {
    if (objectExists.value) {
      await modifyMaintenanceData(useAlerts, values, originalPark.value.id);
    } else {
      await createMaintenanceData(useAlerts, values);
    }
    emit('updated');
  } catch (e) {
    useAlerts.value.errorAlert('Error during Maintenance Data save', e.toString());
  } finally {
    loadingOverlay.value = false;
    usingDefaults.value = false;
  }
}, () => {
  alert('Form has errors');
});

</script>

<i18n>
{
  "en": {
    "maintenance_data": "Maintenance Data",
    "how_approach_client": "Client's telephone and info",
    "electrical_cabinet_type": "Electrical Cabinet Type",
    "electrical_cabinet_position": "Electrical Cabinet Position",
    "electrical_cabinet_with_key": "Electrical Cabinet with Key",
    "cabinet_high_position": "Cabinet in high position",
    "grounded_com_braid": "Grounded COM Braid",
    "gnd_to_neutral": "GND to Neutral",
    "phase_to_neutral": "Phase to Neutral",
    "notes_maintenance": "Notes for Maintenance",
    "pilotage": "Pilotage",
    "pilotage_board_model": "Pilotage Board Model",
    "measurement_board_model": "Measurement Board Model",
    "measurement_board_data": "Measurement Board Data",
    "card_ampere": "Card Ampere",
    "clamp_ampere": "Clamp Ampere",
    "no_additional_data_needed": "No additional data needed",
    "computer_grounded": "Computer Grounded",
    "new_epc": "New EPC",
    "computer_electrical_protection": "Computer Electrical Protection",
    "gsm_modem": "GSM Modem",
    "gsm_modem_data": "GSM Modem Data",
    "sim_provider": "SIM Provider",
    "new_teltonika_cable": "New Teltonika Cable",
    "connectivity_notes": "Connectivity Notes",
    "no_pilotage": "No Pilotage",
    "cp_data": "CP Data",
    "cp": "CP",
    "socket_type": "Socket Type",
    "socket_data": "Socket Data",
    "model": "Model",
    "solenoid": "Solenoid",
    "tips_6mm2": "Tips 6mm2",
    "no_additional_info": "No additional info",
    "capacity_nf": "Capacity nF",
    "communication_cable": "Communication Cable",
    "save_data": "Save Data",
    "fill_defaults": "Fill Defaults",
    "disabled": "Disabled"
  },
  "it": {
    "maintenance_data": "Dati di Manutenzione",
    "how_approach_client": "Numero di telefono e informazioni sul cliente",
    "electrical_cabinet_type": "Tipo di Armadio Elettrico",
    "electrical_cabinet_position": "Posizione dell'Armadio Elettrico",
    "electrical_cabinet_with_key": "Armadio Elettrico con Chiave",
    "cabinet_high_position": "Armadio in posizione elevata",
    "grounded_com_braid": "Cavo COM Messo a Terra",
    "gnd_to_neutral": "Terra a Neutro",
    "phase_to_neutral": "Fase a Neutro",
    "notes_maintenance": "Note per la Manutenzione",
    "pilotage": "Pilotaggio",
    "pilotage_board_model": "Modello Scheda di Pilotaggio",
    "measurement_board_model": "Modello Scheda di Misurazione",
    "measurement_board_data": "Dati Scheda di Misurazione",
    "card_ampere": "Ampere Scheda",
    "clamp_ampere": "Ampere Morsetto",
    "no_additional_data_needed": "Nessun dato aggiuntivo necessario",
    "computer_grounded": "Computer Messo a Terra",
    "new_epc": "Nuovo EPC",
    "computer_electrical_protection": "Protezione Elettrica del Computer",
    "gsm_modem": "Modem GSM",
    "gsm_modem_data": "Dati Modem GSM",
    "sim_provider": "Fornitore SIM",
    "new_teltonika_cable": "Nuovo Cavo Teltonika",
    "connectivity_notes": "Note di Connettività",
    "no_pilotage": "Nessun Pilotaggio",
    "cp_data": "Dati CP",
    "cp": "CP",
    "socket_type": "Tipo di Presa",
    "socket_data": "Dati Presa",
    "model": "Modello",
    "solenoid": "Solenoide",
    "tips_6mm2": "Punte 6mm2",
    "no_additional_info": "Nessuna informazione aggiuntiva",
    "capacity_nf": "Capacità nF",
    "communication_cable": "Cavo di Comunicazione",
    "save_data": "Salva Dati",
    "fill_defaults": "Riempi Predefiniti",
    "disabled": "Disabilitata"
  },
  "fr": {
    "maintenance_data": "Données de Maintenance",
    "how_approach_client": "Numéro de téléphone et informations sur le client",
    "electrical_cabinet_type": "Type d'Armoire Électrique",
    "electrical_cabinet_position": "Position de l'Armoire Électrique",
    "electrical_cabinet_with_key": "Armoire Électrique avec Clé",
    "cabinet_high_position": "Armoire en position élevée",
    "grounded_com_braid": "Tresse COM Mise à la Terre",
    "gnd_to_neutral": "Terre au Neutre",
    "phase_to_neutral": "Phase au Neutre",
    "notes_maintenance": "Notes pour la Maintenance",
    "pilotage": "Pilotage",
    "pilotage_board_model": "Modèle de Carte de Pilotage",
    "measurement_board_model": "Modèle de Carte de Mesure",
    "measurement_board_data": "Données de Carte de Mesure",
    "card_ampere": "Ampère Carte",
    "clamp_ampere": "Ampère Pince",
    "no_additional_data_needed": "Aucune donnée supplémentaire nécessaire",
    "computer_grounded": "Ordinateur Mis à la Terre",
    "new_epc": "Nouveau EPC",
    "computer_electrical_protection": "Protection Électrique de l'Ordinateur",
    "gsm_modem": "Modem GSM",
    "gsm_modem_data": "Données Modem GSM",
    "sim_provider": "Fournisseur SIM",
    "new_teltonika_cable": "Nouveau Câble Teltonika",
    "connectivity_notes": "Notes de Connectivité",
    "no_pilotage": "Pas de Pilotage",
    "cp_data": "Données CP",
    "cp": "CP",
    "socket_type": "Type de Prise",
    "socket_data": "Données de Prise",
    "model": "Modèle",
    "solenoid": "Solénoïde",
    "tips_6mm2": "Embouts 6mm2",
    "no_additional_info": "Pas d'information supplémentaire",
    "capacity_nf": "Capacité nF",
    "communication_cable": "Câble de Communication",
    "save_data": "Enregistrer les Données",
    "fill_defaults": "Remplir par Défaut",
    "disabled": "Désactivée"
  }
}
</i18n>

<style scoped>
.defaults-applied {
  border: 2px solid blue;
  border-radius: 10px;
  padding: 5px;
  margin: 5px;
}
</style>
